import { GlModal } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, __, sprintf } from '~/locale';
export default {
    name: 'JobActionModal',
    i18n: {
        title: s__('PipelineGraph|Are you sure you want to run %{jobName}?'),
        confirmationText: s__('PipelineGraph|Do you want to continue?'),
        actionCancel: {
            text: __('Cancel')
        }
    },
    components: {
        GlModal
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        customMessage: {
            type: String,
            required: true
        },
        visible: {
            type: Boolean,
            required: false,
            default: false
        },
        jobName: {
            type: String,
            required: true
        }
    },
    emits: [
        'change',
        'confirm'
    ],
    computed: {
        modalText () {
            return {
                confirmButton: {
                    text: sprintf(__('Yes, run %{jobName}'), {
                        jobName: this.jobName
                    })
                },
                title: sprintf(this.$options.i18n.title, {
                    jobName: this.jobName
                })
            };
        }
    }
};
